import React from 'react'
// import inputComponents from './inputComponents'
import { checkTextTranslation, getObject, imageAddress, priceStandardView, setObject, translate } from '../../utils/useful'
// import PriceInput from './PriceInput'
// import TextInput from './TextInput'
import SidebarView from '../SidebarView'
// import FixedView from '../FixedView'
import RowTableInvoice from './RowTabeInvoice'
import Collapsible from 'react-collapsible'
import { v4 as uuidv4 } from "uuid";
import Responsive from '../Responsive'
import CommerceInvoiceCalculations from '../CommerceInvoiceCalculations'
import FullfilmentSelectInput from './FullfilmentSelectInput'
import { ObjectId } from 'bson';

class InvoiceInput extends React.Component {
    state = {
        errors: {},
        data: {},
        width: window.innerWidth,
        tab: 1,
        fullProducts: {}
    }

    componentDidMount() {
        this.init()
        window.addEventListener('resize', this.setFormWidth);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setFormWidth)
    }

    componentDidUpdate(prevProps) {

        if (((prevProps.data == null) && (JSON.stringify(this.props.data) !== JSON.stringify(prevProps.data))) || (JSON.stringify(this.props.headers) !== JSON.stringify(prevProps.headers))) {

            this.init()
        }

        // if ((prevProps.data == null && !this.props.data)) {

        //     this.addNew()
        // }

        // if ( (this.props.headers !== prevProps.headers)) {

        //     this.init()
        // }
    }

    getForm = () => {
        // console.log(this.validator())
        if (this.validator()) {
            return this.props.data ? this.props.data : {}
        } else {
            return null
        }
    }



    init = () => {
        // console.log(this.props.data)
        // setTimeout(() => {
        this.makeInitValue(this.props.data)

        // }, 100);
    }


    validator() {
        let valid = true
        let errors = {}
        this.props.headers.forEach(header => {
            if (header.information?.required) {

                let value = getObject(this.state.data, header.key)

                if (header.type == 'ImageInput' || header.type == 'FileInput') {

                    if (!value || value === '') {
                        value = getObject(this.state.data, ('**files.' + header.key), 1)
                    }
                    if (!value || value === '') {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                } else {
                    // let value = getObject(this.state.data, header.key)
                    if (!value || value === '') {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                }
                if (header.type == 'PhoneInput') {
                    // let value = getObject(this.state.data, header.key)
                    if (!value || value.length < 14) {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                }
            }
        })

        this.setState({ errors })
        return valid
    }

    makeInitValue(rawData) {

        let data = rawData ? JSON.parse(JSON.stringify(rawData)) : null

        // console.log(this.props.data)
        // if (data == null) {
        //     data = {}
        // }
        // if (this.props.headers) {

        //     this.props.headers.forEach(header => {
        //         if (data[header.key] == null && header.information?.default != null) {
        //             data[header.key] = header.information?.default
        //         }
        //     });
        // }
        // if (!Array.isArray(data) || (Array.isArray(data) && data.length == 0)) {

        // }
        // console.log(data)

        this.setState({ data: data, show: true }, () => {
            this.setFormWidth()
            setTimeout(() => {

                if (Array.isArray(this.state.data)) {
                    let lastRow = this.state.data[this.state.data.length - 1]
                    if (lastRow.product) {
                        this.addNew()
                    }
                } else {
                    this.addNew()
                }

            }, 0);
        })

    }

    setFormWidth = () => {
        if (this.form) {
            this.setState({ width: this.form.getBoundingClientRect().width })
        }
    }



    addNew = () => {

        let data = this.state.data ? JSON.parse(JSON.stringify(this.state.data)) : []

        const hasEmptyProduct = data.some(item => !item.product);

        // console.log("addNew", hasEmptyProduct)

        if (hasEmptyProduct) {
            return
        }

        // console.log(data)
        // if (!Array.isArray(data)) {
        //     data = []
        // }
        // let id = uuidv4()
        let id = String(new ObjectId())

        if (!Array.isArray(data)) {
            data = []
        }
        data.push({ _id: id })

        // console.log(data)

        // console.log(this.props.header.key,data)

        this.setState({ data: data })
        // this.props.changeValue(this.props.header.key, data, this.props.extra)
    }
    // addNew1 = () => {

    //     let data = this.props.data
    //     if (!data) {
    //         data = {}
    //     }
    //     if (!Array.isArray(data.items)) {
    //         data.items = []
    //     }
    //     data.items.push({})
    //     this.props.changeValue(this.props.header.key, data)
    //     this.fixedViewMore.hideView()
    // }

    removeRow = (index) => {
        let data = this.state.data ? JSON.parse(JSON.stringify(this.state.data)) : []
        // data = data ? [...data] : null

        // console.log(data, index)
        if (Array.isArray(data)) {

            data.splice(index, 1)

        }

        this.props.changeValue(this.props.header.key, data)
        this.setState({ data })
    }


    changeFiles = (files, key, extra) => {
        // let data = this.state.data ?? {}

        // if (data['**files'] == null) {
        //     data['**files'] = {}
        // }
        // value.formType = ''

        // this.props.header.information.headers.forEach(header => {
        //     if (header.key == key) {
        //         value.formType = header.type
        //         // value.single = header.information?.single
        //     }
        // });

        // data['**files'][key] = value
        // console.log(data)
        // this.setState({ data })
        // console.log(extra)
        // console.log(files)

        this.props.changeValue('**files', { [this.props.header.key + '.' + extra?.index + "~" + key]: files }, { append: 'object' })
        // this.props.changeValue('**files.' + this.props.header.key + '.' + extra?.index + "~" + key, files)

        // this.props.changeValue('**files', { [this.props.header.key+'!!' + '.' + key ]: files })

    }

    changeItem = (key, value, extra, fullObject, init) => {
        // console.log("this.changeItem",key, value, extra)

        if (!init) {
            let data = this.state.data ? JSON.parse(JSON.stringify(this.state.data)) : []

            if (!Array.isArray(data)) {
                data = [];
            }

            const newIndex = extra.index;
            const newItem = value;

            const existingIndex = data.findIndex((item, idx) =>
                item?.product === newItem.product && idx !== newIndex
            );

            if (existingIndex !== -1) {
                const existingItem = data[existingIndex];

                existingItem.count = (existingItem.count || 0) + (newItem.count || 0);
                existingItem.amount = (existingItem.amount || 0) + (newItem.amount || 0);

                if (newItem.amounts && typeof newItem.amounts === 'object') {
                    existingItem.amounts = { ...existingItem.amounts };
                    for (const [k, v] of Object.entries(newItem.amounts)) {
                        if (k != 'base') {

                            existingItem.amounts[k] = (existingItem.amounts[k] || 0) + v;
                        }
                    }
                }

                if (newIndex < data.length) {
                    data.splice(newIndex, 1);
                }
            } else {
                data[newIndex] = newItem;
            }

            let final = data ? JSON.parse(JSON.stringify(data)) : null
            if (Array.isArray(final)) {
                let lastRow = final[final.length - 1]
                if (!lastRow.product) {
                    final.splice(final.length - 1, 1)
                }
            }
            // console.log("data", data)
            // console.log("final", final)

            this.props.changeValue(this.props.header?.key, final);
            this.setState({ data }, () => {
                setTimeout(() => {
                    this.updatePrices(() => {
                        const hasEmptyProduct = data.some(item => !item.product);
                        setTimeout(() => {
                            if (!hasEmptyProduct && !init) {
                                this.addNew();
                            }
                        }, 100);
                    });
                }, 10);
            })
        }
    };
    // changeItem = (key, value, extra, fullObject) => {

    //     // console.log("changeItem1", key, value, extra, fullObject)
    //     let data = this.props.data ? [ ...this.props.data } : {}
    //     if (!Array.isArray(data.items)) {
    //         data.items = []
    //     }
    //     data.items[extra.index] = value

    //     // console.log(data)
    //     // console.log(`${this.props.header?.key}.${key}`)
    //     // setObject(data, 'items', value, false, extra.index)
    //     this.props.changeValue(`${this.props.header?.key}`, data)

    //     // console.log(data)

    //     setTimeout(() => {
    //         this.updatePrices(()=>{})
    //     }, 10);
    //     // return

    //     // // console.log(data)


    //     // console.log(data.items)
    //     // this.props.changeValue('items', data.items)


    // }

    setFullProduct = (product) => {

        // console.log(product)
        let fullProducts = this.state.fullProducts
        fullProducts[product?._id] = product
        this.setState({ fullProducts })

    }

    // changeValue = (key, value, extra, fullObject, updatePrice) => {


    //     console.log('changeValue', key, value, fullObject)


    //     let data = this.props.fullData.items

    //     let index = extra.index
    //     let oldValue = getObject(data, key, null, null, index)

    //     if (oldValue && typeof oldValue == 'object') {
    //         oldValue = oldValue?._id
    //     }

    //     if (Array.isArray(data)) {
    //         data = setObject(data, key, value, false, index)
    //         this.props.changeValue(this.props.header.key, { ...this.props.data, ...{ items: data } })
    //     }


    //     if (updatePrice) {
    //         setTimeout(() => {
    //             this.updatePrices()

    //         }, 10);
    //     }

    // }



    formColBuilder(col) {
        let finalCol = 'col-12'

        if (100 < this.state.width && col) {
            finalCol = 'col-' + col
        }

        return finalCol
    }

    renderHeader(headers) {
        if (headers) {
            return (headers.map((header, index) => {
                return (

                    <div key={index} className={" w-100 pt-1 pb-2 px-2 text-uppercase  " + (index != headers.length - 1 ? 'invoice-table-border ' : '') + (' text-start ') + this.formColBuilder(header.col)} >
                        <label style={{ color: '#000', fontWeight: '600' }} className={'text-smaller mrd-1 mld-1  ' + (header.information?.required ? 'required' : '')}>{checkTextTranslation(header.information?.label)}</label>
                        {header.information?.hint && (
                            <div className={"mx-1 text-start text-smallest "}>
                                <div style={{ color: '#9ab', fontWeight: '500' }}>{checkTextTranslation(header.information?.hint)}</div>
                            </div>
                        )}
                    </div>
                )
            }))
        }
    }

    changeValue = (key, value) => {

    }


    changeShipping = (key, value) => {

        // this.props.changeValue(this.props.header.key, { ...this.props.data, ...{ shipping: value } })
        setTimeout(() => {
            this.updatePrices()
        }, 10);
    }
    changeDiscount = (key, value) => {
        // this.props.changeValue(this.props.header.key, { ...this.props.data, ...{ discount: value } })
        setTimeout(() => {
            this.updatePrices()
        }, 10);
    }

    updateAdjustments = (adjustments) => {
        // this.props.changeValue(this.props.header.key, { ...this.props.data, ...{ adjustment: value } })
        let amountsKey = 'amounts'
        let amounts = this.props.fullData?.[amountsKey] ?? {}
        amounts.adjustments = adjustments
        this.props.changeValue(amountsKey, amounts)
        setTimeout(() => {
            this.updatePrices()
        }, 10);
    }

    updateAdjustmentTitle = (key, value) => {
        // this.props.changeValue(this.props.header.key, { ...this.props.data, ...{ adjustmentTitle: value } })
    }

    updatePrices = (cb) => {
        let subtotal = this.calcSubtotal()
        let amountsKey = 'amounts'
        let total = subtotal //- (this.props.fullData?.[amountsKey].discount ?? 0) + (this.props.fullData?.[amountsKey].shipping ?? 0) + (this.props.fullData?.[amountsKey].tax ?? 0) + (this.props.fullData?.[amountsKey].adjustment ?? 0)

        let amounts = this.props.fullData?.[amountsKey] ?? {}

        if (Array.isArray(amounts.adjustments)) {

            for (let i = 0; i < amounts.adjustments.length; i++) {
                const adjustment = amounts.adjustments[i];
                if (adjustment?.amount) {
                    total = total + adjustment.amount
                }
            }

        }

        // console.log(subtotal, total)
        // let data = this.props.fullData ? { ...this.props.fullData } : {}

        // if (!data.amounts) {


        amounts.items = { base: subtotal, total }

        if (!amounts.totals) {
            amounts.totals = {}
        }

        amounts.totals = { final: total, beforeTax: total }

        // console.log(amounts)
        this.props.changeValue("amount", amounts.totals?.final)
        setTimeout(() => {
            this.props.changeValue(amountsKey, amounts)
        }, 50);
        if (cb) (
            cb()
        )

    }




    calcSubtotal = () => {
        let total = 0
        // console.log(this.props.data)
        if (Array.isArray(this.state.data)) {
            for (let i = 0; i < this.state.data.length; i++) {
                const element = this.state.data[i];
                // console.log(element)
                total = total + (element.amounts?.final ?? 0)
            }
        }

        return total

    }


    setFetchedData = (key, data) => {
        let fetchedData = this.state.fetchedData
        if (!fetchedData) {
            fetchedData = {}
        }

        fetchedData[key] = data

        // console.log(fetchedData)

        this.setState({ fetchedData })
    }


    render() {
        let headers = this.props.header.information?.headers
        // console.log(this.props.data)
        // console.log(this.props.fullData)

        if (this.state.show) {

            return (
                <div className="w-100 subform  pt-0" ref={(el) => this.form = el}>
                    <div className={""} style={{ overflow: 'auto' }}>

                        <div className="flexc w-100  p-0 h-100 w-100" style={{ borderRadius: '4px 4px 0px 0px', backgroundColor: '#f2f2f2', borderBottom: '1px solid #eee' }}>
                            {!this.props.header.information?.removeDisabled && (
                                <button className="flexcc p-1" style={{ width: 20 }}>
                                    <img src="/images/remove-2.svg" width="16px" style={{ opacity: 0 }} alt='' />
                                </button>
                            )}

                            <div className="d-flex w-100" style={{ flexWrap: 'nowrap', }}>
                                {this.renderHeader(headers)}
                            </div>

                        </div>


                        {Array.isArray(this.state.data) && this.state.data?.map((prop, index) => {
                            return (
                                <div className="flexc w-100" key={prop?._id ?? index} style={{ borderBottom: '1px solid #eee' }}>

                                    <div key={index} className="d-flex w-100" style={{ flexWrap: 'nowrap', }}>
                                        <RowTableInvoice addNew={this.addNew} removeRow={() => this.removeRow(index)} header={this.props.header} changeValue={this.changeItem} sidebarView={this.sidebarView} headers={headers} width={this.props.width} rawData={prop} index={index} extra={{ index }} setFullProduct={this.setFullProduct} variables={this.props.variables} setFetchedData={this.setFetchedData} fetchedData={this.state.fetchedData} />
                                    </div>

                                </div>

                            )
                        })}
                    </div>

                    {/* {console.log(this.props.data?.items)} */}

                    {(!Array.isArray(this.state.data) || this.state.data?.length == 0) && (
                        <p className="text-smaller text-center mt-3 mb-1 text-uppercase text-bold" style={{ color: '#9ab' }}>{translate('useful.foundNothing')}</p>
                    )}
                    {/* {!this.props.header.information?.addDisabled && (
                        <div className="flexcb px-2">
                            <button onClick={() => this.addNew()} className="px-2 py-2 flexcc" style={{ backgroundColor: '#677dc4', borderRadius: 4 }}>
                              <div className="flexcc text-semibig mrd-2 p-0" style={{backgroundColor:'#fff',width:'14px',height:'14px',borderRadius:30,color:'#677dc4'}}><p className="p-0 m-0" style={{lineHeight:0}}>+</p></div>
                                <p className="white text-smaller text-uppercase text-bold">{translate("useful.addNew")}</p>
                            </button>
                        </div>
                    )} */}
                    <div className=" mt-2">

                        <div className='flexcb '>
                            <div className="w-100 mb-2 px-0">
                                {/* <button onClick={() => this.addNew()} className="px-2 py-2 flexcc" style={{ borderRadius: 4, color: '#007aff' }}>
                                <p className=" text-smaller text-uppercase text-bold">+ {translate("useful.addItem")}</p>
                            </button> */}
                                <button onClick={() => this.addNew()} className="px-1 py-2 flexcc" style={{ color: '#007aff', borderRadius: 4 }}>
                                    <div className="flexcc text-semibig mrd-2 p-0" style={{ backgroundColor: '#007aff', width: '16px', height: '16px', borderRadius: 30, color: '#fff' }}><p className="p-0 m-0" style={{ lineHeight: 0 }}>+</p></div>
                                    <p className=" font-size-14 px-1 text-semibold">{translate("useful.addItem")}</p>
                                </button>
                            </div>
                            {/* <div className=""></div> */}


                            <div>
                                <button onClick={() => this.addNew()} className="px-1 py-2 flexcc" style={{ color: '#007aff', borderRadius: 4 }}>
                                    <div className="flexcc text-semibig mrd-2 p-0" style={{ backgroundColor: '#007aff', width: '16px', height: '16px', borderRadius: 30, color: '#fff' }}><p className="p-0 m-0" style={{ lineHeight: 0 }}>+</p></div>
                                    <p className=" font-size-14 px-1 text-semibold no-wrap">{translate("Add fullfilment")}</p>
                                </button>
                            </div>

                        </div>

                        <div>
                            <FullfilmentSelectInput items={this.state.data} fulfillmentInfo={this.props.fullData?.fulfillmentInfo} width={this.props.width} fullProducts={this.state.fullProducts} />
                        </div>


                        <div className="flex-1 pld-5 px-0 d-flex justify-content-end mt-2" >

                            <Responsive width={this.props.width} media={{ xs: '12', sm: '12', md: '450px', lg: '450px', xl: '450px' }}>

                                <div className="p-3 pb-4 br-8" style={{ flex: 1, border: '1px dashed #bbb' }}>
                                    {/* <div className="flexcb">
                                        <p className="font-size-14 text-semibold" >{translate("Subtotal")}</p>
                                        <p className="text-small text-bold ">{priceStandardView(this.props.data?.subtotal) ?? 0}</p>
                                    </div>

                                    <div className="flexcb mt-3 ">
                                        <div className="flexc flex-1">
                                            <div className="mrd-3 w-100">
                                                <p className="font-size-14 text-semibold ">{translate("Shipping Charges")}</p>
                                                <button className="text-smaller mt-1 p-0" style={{ color: '#007aff' }}>{translate("Tax on shipping?")}</button>
                                            </div>
                                            <div style={{ width: 120, backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: 2, padding: '4px 6px' }}>
                                                <PriceInput data={this.props.data?.shipping} header={{ key: '', information: {} }} changeValue={this.changeShipping} />
                                            </div>
                                        </div>
                                        <div className="flex-1 text-end">
                                            <p className="text-small text-bold ">{priceStandardView(this.props.data?.shipping) ?? 0}</p>
                                        </div>
                                    </div>


                                    <div className="flexcb mt-3">
                                        <div className="flexc flex-1">
                                            <div className="mrd-3 w-100">
                                                <p className="font-size-14 text-semibold ">{translate("Discount")}</p>
                                            </div>
                                            <div style={{ width: 120, backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: 2, padding: '4px 6px' }}>
                                                <PriceInput data={this.props.data?.discount} header={{ key: '', information: {} }} changeValue={this.changeDiscount} />
                                            </div>
                                        </div>
                                        <div className="flex-1 text-end">
                                            <p className="text-small text-bold ">{this.props.data?.discount ? "-" + priceStandardView(this.props.data?.discount) : 0}</p>
                                        </div>
                                    </div>





                                    <div className="flexcb mt-3">
                                        <div className="flexc flex-1">
                                            <div className="mrd-3 w-100 flexc">
                                                <div style={{ width: "100%", maxWidth: 120, backgroundColor: '#fff', border: '1px dashed #ddd', borderRadius: 2, padding: '4px 6px' }}>
                                                    <TextInput data={this.props.data?.adjustmentTitle} header={{ key: '', information: { placeholder: '{{lang}}adjustment' } }} changeValue={this.updateAdjustmentTitle} />
                                                </div>
                                            </div>
                                            <div style={{ width: 120, backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: 2, padding: '4px 6px' }}>
                                                <PriceInput data={this.props.data?.adjustment} header={{ key: '', information: { negativeAllowed: true } }} changeValue={this.updateAdjustment} />
                                            </div>
                                        </div>
                                        <div className="flex-1 text-end">
                                            <p className="text-small text-bold ">{priceStandardView(this.props.data?.adjustment) ?? 0}</p>
                                        </div>
                                    </div>


                                    <div className="flexcb mt-4 ">
                                        <div className="flexc flex-1 px-1">
                                            <div className="mrd-3 w-100">
                                                <p className="text-normal text-bold " style={{ color: '#000' }}>{translate("General total")}</p>
                                            </div>

                                        </div>
                                        <div className="flex-1 text-end">
                                            <p className="text-small text-bold ">{priceStandardView(this.props.data?.total) ?? 0}</p>
                                        </div>
                                    </div> */}


                                    <CommerceInvoiceCalculations variables={this.props.variables} adminMode={true} cart={this.props.fullData} updateAdjustments={this.updateAdjustments} />





                                </div>

                            </Responsive>
                        </div>

                    </div>

                    {this.props.errors && (typeof this.props.errors == 'string') && (
                        <div className="col-12 text-start">
                            <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.props.errors)}</small>
                        </div>
                    )}


                    <SidebarView width={this.props.width} ref={el => this.sidebarView = el} hideOverlay={false} left={50} widthCondition={{ xs: "100%", sm: "100%", md: '50%', lg: "33.3%", xl: "25%" }}>
                        <div className='w-100 h-100 scroll-no-scrollbar'>
                            <div>
                                <div>
                                    <div className='px-2 py-2' style={{ background: '#00000010' }}>
                                        <p style={{ fontSize: 18, fontWeight: '500' }}>
                                            {translate("Customer Details")}
                                        </p>
                                    </div>
                                    <div className='px-1' style={{ background: '#FAFAFA' }}>
                                        <div className="w-100 flexcb" >
                                            <div className="w-100 px-1 py-2 flexc" style={{}}>
                                                <div className='mrd-2'>

                                                    <img src='/assets/images/BingWallpaper.jpg' style={{ width: 40, height: 40, borderRadius: 100 }} />

                                                </div>

                                                <div>

                                                    {/* <p style={{ fontSize: 14 }}>{translate("Sales and Purchase Items")}</p> */}

                                                    <p style={{ fontSize: 16, fontWeight: '500' }}>{translate("test item")} </p>
                                                    <p style={{ fontSize: 13, fontWeight: '400', color: '#aaa' }}>@test</p>

                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    <div className='my-3 mx-3'>
                                        <div className='flexc '>
                                            <div className='flex-1 flex-column'>
                                                <p style={{ fontSize: 14, color: '#495057' }}>{translate("Receivables")}</p>
                                                <p style={{ fontSize: 15, color: '#408dfb', }}>$3,000.00</p>
                                            </div>
                                            <div className='flex-1 flex-column align-items-end d-flex'>
                                                <p style={{ fontSize: 14, color: '#495057' }}>{translate("Unused Credits")}</p>
                                                <p style={{ fontSize: 15, color: '#408dfb', }}>$3,000.00</p>
                                            </div>
                                        </div>
                                        <div>
                                            <button onClick={() => this.setState({ isOpen: !this.state.isOpen })} className='mt-2'>
                                                <p style={{ color: '#408dfb', fontSize: 13 }}>
                                                    {translate("Other Details")}
                                                </p>
                                            </button>
                                            <Collapsible open={this.state.isOpen}>
                                                <div className='my-2'>
                                                    <div className='d-flex'>
                                                        <div className='flex-2'>
                                                            <p style={{ fontSize: 12, color: '#495057' }}>{translate("Customer Type")}</p>
                                                        </div>
                                                        <div className='flex-3'>
                                                            <p style={{ fontSize: 14, color: '#000' }}>{translate("Business")}</p>
                                                        </div>
                                                    </div>
                                                    <div className='d-flex'>
                                                        <div className='flex-2'>
                                                            <p style={{ fontSize: 12, color: '#495057' }}>{translate("Currency Code")}</p>
                                                        </div>
                                                        <div className='flex-3'>
                                                            <p style={{ fontSize: 14, color: '#000' }}>{translate("CAD")}</p>
                                                        </div>
                                                    </div>
                                                    <div className='d-flex'>
                                                        <div className='flex-2'>
                                                            <p style={{ fontSize: 12, color: '#495057' }}>{translate("Payment Terms")}</p>
                                                        </div>
                                                        <div className='flex-3'>
                                                            <p style={{ fontSize: 14, color: '#000' }}>{translate("Due on Receipt")}</p>
                                                        </div>
                                                    </div>
                                                    <div className='d-flex'>
                                                        <div className='flex-2'>
                                                            <p style={{ fontSize: 12, color: '#495057' }}>{translate("Portal Status")}</p>
                                                        </div>
                                                        <div className='flex-3'>
                                                            <p style={{ fontSize: 14, color: '#000' }}>{translate("Disabled")}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Collapsible>
                                        </div>
                                    </div>
                                </div>
                                <div className='d-flex w-100 ' style={{ borderBottom: '1px solid #dfdfdf' }}>
                                    <div className='flex-1 flexcc'>

                                        <button cla onClick={() => this.setState({ tab: 0 })} style={this.state.tab == '0' ? { borderBottomWidth: '3px', borderBottomStyle: ' solid ', borderImage: 'linear-gradient(to right ,#4685cccb , #4646cc) 5', marginBottom: -1, paddingBottom: 4, width: '100%' } : {}}>
                                            <p>
                                                {translate("Item Details")}
                                            </p>
                                        </button>
                                    </div>
                                    <div className='flex-1 flexcc'>

                                        <button cla onClick={() => this.setState({ tab: 1 })} style={this.state.tab == '1' ? { borderBottomWidth: '3px', borderBottomStyle: ' solid ', borderImage: 'linear-gradient(to right ,#4685cccb , #4646cc) 5', marginBottom: -1, paddingBottom: 4, width: '100%' } : {}}>
                                            <p>
                                                {translate("Transactions")}
                                            </p>
                                        </button>
                                    </div>
                                    <div className='flex-1 flexcc'>

                                        <button cla onClick={() => this.setState({ tab: 2 })} style={this.state.tab == '2' ? { borderBottomWidth: '3px', borderBottomStyle: ' solid ', borderImage: 'linear-gradient(to right ,#4685cccb , #4646cc) 5', marginBottom: -1, paddingBottom: 4, width: '100%' } : {}}>
                                            <p>
                                                {translate("Transactions")}
                                            </p>
                                        </button>
                                    </div>
                                </div>
                                <div>
                                    {this.state.tab == '0' && (
                                        <div>
                                            <div style={{ padding: '20px 18px', borderBottom: '1px solid #eee' }}>
                                                <div>
                                                    <p>
                                                        {translate("Sales Information")}
                                                    </p>
                                                </div>
                                                <div className='mt-3'>
                                                    <div className='flexc'>
                                                        <div className='flex-1'>
                                                            <p style={{ fontSize: 14, color: '#495057' }}>{translate("Price")}</p>
                                                        </div>
                                                        <div className='flex-1 mt-2'>
                                                            <p style={{ fontSize: 15 }}>$3,000.00</p>
                                                        </div>
                                                    </div>
                                                    <div className='flexc'>
                                                        <div className='flex-1'>
                                                            <p style={{ fontSize: 14, color: '#495057' }}>{translate("Account")}</p>
                                                        </div>
                                                        <div className='flex-1 mt-2'>
                                                            <p style={{ fontSize: 15 }}>{translate("Sales")}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='mb-2' style={{ padding: '20px 18px', borderBottom: '1px solid #eee' }}>
                                                <div>
                                                    <p>
                                                        {translate("Purchase Information")}
                                                    </p>
                                                </div>
                                                <div className='mt-3'>
                                                    <div className='flexc'>
                                                        <div className='flex-1'>
                                                            <p style={{ fontSize: 14, color: '#495057' }}>{translate("Price")}</p>
                                                        </div>
                                                        <div className='flex-1'>
                                                            <p style={{ fontSize: 15 }}>$2,500.00</p>
                                                        </div>
                                                    </div>
                                                    <div className='flexc'>
                                                        <div className='flex-1'>
                                                            <p style={{ fontSize: 14, color: '#495057' }}>{translate("Account")}</p>
                                                        </div>
                                                        <div className='flex-1 mt-2'>
                                                            <p style={{ fontSize: 15 }}>{translate("Cost of Goods Sold")}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {/* {this.state.tab == '1' && (
                                                            <div >
                                                                <div style={{ padding: '20px 18px' }}>
                                                                    <div className='flexcb'>
                                                                        <button onClick={() => this.fixedView1.showView()} className='w-100'>

                                                                            <div className='flexc' ref={el => this.nodeRefInvoice = el}>
                                                                                <p>{translate("Invoice")}</p>
                                                                            </div>
                                                                        </button>
                                                                        <button onClick={() => this.fixedView.showView()} className='w-100 d-flex justify-content-end'>

                                                                            <div className='flexc' ref={el => this.nodeRefStatus = el}>
                                                                                <p className='mrd-1'>{translate("Status :")}</p>
                                                                                <p>{translate("ALL")}</p>
                                                                            </div>
                                                                        </button>
                                                                    </div>
                                                                    <FixedView ref={el => this.fixedView1 = el} width={this.props.width} nodeRef={this.nodeRefInvoice} zIndex={10} maxWidth={100}>
                                                                        <div className="w-100 px-2 py-3" style={{ background: '#F5F5F5', }}>
                                                                            <p style={{ fontSize: 13 }}>{translate("Estimate")}</p>
                                                                            <p style={{ fontSize: 13 }}>{translate("Invoice")}</p>
                                                                            <p style={{ fontSize: 13 }}>{translate("Credit Note")}</p>
                                                                            <p style={{ fontSize: 13 }}>{translate("Recurring Invoice")}</p>
                                                                        </div>
                                                                    </FixedView>
                                                                    <FixedView ref={el => this.fixedView = el} width={this.props.width} nodeRef={this.nodeRefStatus} zIndex={10} maxWidth={100}>
                                                                        <div className="w-100 px-2 py-3" style={{ background: '#F5F5F5', }}>
                                                                            <p style={{ fontSize: 13 }}>{translate("All")}</p>
                                                                            <p style={{ fontSize: 13 }}>{translate("Draft")}</p>
                                                                            <p style={{ fontSize: 13 }}>{translate("ClientVieweb")}</p>
                                                                            <p style={{ fontSize: 13 }}>{translate("partiallyPaid")}</p>
                                                                            <p style={{ fontSize: 13 }}>{translate("UnPaid")}</p>
                                                                            <p style={{ fontSize: 13 }}>{translate("Overdue")}</p>
                                                                            <p style={{ fontSize: 13 }}>{translate("Void")}</p>
                                                                        </div>
                                                                    </FixedView>
                                                                </div>
                                                                <div className="w-100 flexc" style={{ borderWidth: '1px 0 ', borderColor: '#e8e8e8', borderStyle: 'solid', background: '#FAFAFA', padding: '20px 18px' }}>

                                                                    <div className='mrd-2'>
                                                                        <input type='checkbox' />
                                                                    </div>
                                                                    <div>
                                                                        <p style={{ fontSize: 14 }}>{translate(" Show only test's transactions")} </p>
                                                                    </div>

                                                                </div>
                                                                <div style={{ paddingBottom: 8, margin: '20px 18px', borderBottom: '1px solid #e8e8e8' }}>
                                                                    <div className='flexcb'>
                                                                        <div>
                                                                            <p style={{ fontSize: 14, color: '#495057' }}>{translate("test")}</p>
                                                                        </div>
                                                                        <div className='flexc'>
                                                                            <p className='mrd-1' style={{ fontSize: 14, color: '#495057' }}>{translate("Item Price")} </p>
                                                                            <div style={{}}>
                                                                                <p style={{ fontSize: 16, }}>$3,000.00</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='flexcb mt-2'>
                                                                        <div className='flexc'>
                                                                            <div className='mrd-2 prd-2' style={{ borderRight: '1px solid #ddd' }}>
                                                                                <p style={{ fontSize: 14, color: '#495057' }}>INV-000001</p>
                                                                            </div>
                                                                            <div>

                                                                                <p style={{ fontSize: 14, color: '#495057' }}>2022/12/05</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className='flexc'>
                                                                            <p className='mrd-1' style={{ fontSize: 14, color: '#495057' }}>{translate("Quantity Sold")}</p>
                                                                            <p style={{ fontSize: 16 }}>1.00</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className='mt-2'>
                                                                        <p style={{ color: '#28a745', fontSize: 13 }}>
                                                                            {translate(" Paid")}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div style={{ paddingBottom: 8, margin: '20px 18px', borderBottom: '1px solid #e8e8e8' }}>
                                                                    <div className='flexcb'>
                                                                        <div>
                                                                            <p style={{ fontSize: 14, color: '#495057' }}>{translate("test")}</p>
                                                                        </div>
                                                                        <div className='flexc'>
                                                                            <p className='mrd-1' style={{ fontSize: 14, color: '#495057' }}>{translate("Item Price")} </p>
                                                                            <div style={{}}>
                                                                                <p style={{ fontSize: 16, }}>$3,000.00</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='flexcb mt-2'>
                                                                        <div className='flexc'>
                                                                            <div className='mrd-2 prd-2' style={{ borderRight: '1px solid #ddd' }}>
                                                                                <p style={{ fontSize: 14, color: '#495057' }}>INV-000001</p>
                                                                            </div>
                                                                            <div>

                                                                                <p style={{ fontSize: 14, color: '#495057' }}>2022/12/05</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className='flexc'>
                                                                            <p className='mrd-1' style={{ fontSize: 14, color: '#495057' }}>{translate("Quantity Sold")}</p>
                                                                            <p style={{ fontSize: 16 }}>1.00</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className='mt-2'>
                                                                        <p style={{ color: '#ff660f', fontSize: 13 }}>
                                                                            {translate("Overdue")}
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        )} */}
                                </div>
                            </div>
                        </div>
                    </SidebarView>


                </div>
            )
        } else {
            return (<div></div>)
        }
    }
}

export default InvoiceInput;